export default class AutoCompleteDTO {
    public value!: string;

    public title!: string;

    constructor(value: string, title: string) {
        this.value = value;
        this.title = title;
    }
}